enum CustomFeature {
    USE_GPP_PARCEL_SHOPS_MANAGEMENT = 'UseGppParcelShopsManagement',
    USE_ASA_PRIVILEGES = 'UseAsaPrivileges',
    PROVIDE_REVERT_SHIPPER_ADDRESS = 'ProvideRevertShipperAddress',
    ALLOW_REDIRECTED_FORWARD_REASON = 'AllowRedirectedForwardReason',
    ADD_PO_TIME_ZONE_HEADER = 'AddPoTimeZoneHeader'
}

export { CustomFeature };
